/**
 * Axios Configuration for MarIA Health Care
 *
 * Simplified HTTP client configuration.
 * Firebase Auth is handled by AuthContext, not by axios interceptors.
 *
 * UPDATE (2026-01-10): Removed legacy refresh token interceptors.
 * Authentication is now handled entirely by Firebase Anonymous Auth.
 * The ADK /run_sse endpoint uses Authorization header with Firebase ID token.
 */
import axios from "axios";

// API base URL from environment
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "";

/**
 * Axios instance for backend API calls
 * Used primarily for /api/init and /api/consent endpoints.
 * Chat functionality uses fetch() directly for SSE streaming.
 */
const api = axios.create({
    baseURL: API_BASE_URL ? `${API_BASE_URL}/api` : "/api",
    headers: {
        "Content-Type": "application/json",
    },
});

export default api;

/**
 * Get API base URL for direct fetch calls
 */
export const getApiBaseUrl = (): string => {
    return API_BASE_URL || "";
};
